import { render, staticRenderFns } from "./exames-atrasados.vue?vue&type=template&id=9e0777dc&"
import script from "./exames-atrasados.vue?vue&type=script&lang=js&"
export * from "./exames-atrasados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports